import { formatARS } from '@gl/shared';

const timeFormatters = new Map<string, Intl.DateTimeFormat>();

export function formatTime(iso: string, timeZone: string): string {
  let f = timeFormatters.get(timeZone);
  if (!f) {
    f = new Intl.DateTimeFormat('es-AR', { hour: '2-digit', minute: '2-digit', timeZone });
    timeFormatters.set(timeZone, f);
  }
  return f.format(new Date(iso));
}

/** "2026-10-15" → "jue 15/10" (fecha de calendario, sin zonas). */
export function formatBusinessDate(date: string, opts: { weekday?: boolean; year?: boolean } = {}): string {
  const d = new Date(`${date}T12:00:00Z`);
  return new Intl.DateTimeFormat('es-AR', {
    timeZone: 'UTC',
    day: '2-digit',
    month: '2-digit',
    ...(opts.weekday !== false ? { weekday: 'short' } : {}),
    ...(opts.year ? { year: 'numeric' } : {}),
  }).format(d);
}

/** Diferencia de arqueo con signo: "+$ 500", "−$ 300", "$ 0". */
export function formatSignedARS(cents: number): string {
  if (cents === 0) return formatARS(0);
  return `${cents > 0 ? '+' : '−'}${formatARS(Math.abs(cents))}`;
}
